import React, { FunctionComponent, ReactNode, useContext } from 'react';
import styles from './internal-link.module.scss';
import { Link } from 'gatsby';
import { Location } from '@reach/router';
import { AppStore } from '../../store/app.context';

export interface IInternalLinkProps {
  children: ReactNode;
  url: string;
  className?: string;
  activeClassName?: string;
  codename?: string;
  id?: string;
}

export const InternalLink: FunctionComponent<IInternalLinkProps> = props => {
  const { children, url, className, activeClassName, id } = props;
  const {
    state: {
      showPageState: { currentLanguage }
    }
  } = useContext(AppStore);

  const createUrl =
    currentLanguage !== 'en' ? `/${currentLanguage}${url}` : `${url}`;
  const validUrl = createUrl.replace(/\/\//g, '/');

  return (
    <Location>
      {({ location }): JSX.Element => (
        <Link
          getProps={({ isPartiallyCurrent }): { className: string } | '' =>
            isPartiallyCurrent
              ? {
                  className: `${activeClassName} ${
                    className ? className : styles.link
                  }`
                }
              : ''
          }
          state={{ prevUrl: location.pathname }}
          activeClassName={activeClassName}
          to={validUrl}
          className={className ? className : styles.link}
          id={id}
        >
          {children}
        </Link>
      )}
    </Location>
  );
};
